/** @flow */

import * as actions from "@modules/shared/constants/actions";
import * as hierarchyReducers from "./reducers";
import initialState from "./state";
import type { HierarchyState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: HierarchyState = initialState, action: Object): Object => {
  const act = {
    [actions.GetHierarchyTree]: hierarchyReducers.onGetHierarchyTree,
    [actions.GetHierarchyTreeSuccess]: hierarchyReducers.onGetHierarchyTreeSuccess,
    [actions.GetHierarchyTreeError]: hierarchyReducers.onGetHierarchyTreeError,
    [actions.GetMyHierarchyTree]: hierarchyReducers.onGetHierarchyTree,
    [actions.GetMyHierarchyTreeSuccess]: hierarchyReducers.onGetMyHierarchyTreeSuccess,
    [actions.GetMyHierarchyTreeError]: hierarchyReducers.onGetMyHierarchyTreeError,
    [actions.ResetMyHierarchyTree]: hierarchyReducers.onResetMyHierarchyTree,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
